import * as stylex from '@stylexjs/stylex';
import { Layer } from 'foundations-components/transitional/components/Layer';
import { Inline } from 'trellis-components/components/layout/Inline';
import { layers } from '../../constants/Layers.stylex';
import { jsx as _jsx } from "react/jsx-runtime";
const AutosaveAlertsContainer = ({
  children
}) => {
  return /*#__PURE__*/_jsx(Layer, {
    rootNode: document.querySelector('body') || undefined,
    children: /*#__PURE__*/_jsx("div", Object.assign({}, {
      className: "x1lliihq xu96u03 xixxii4 x13vifvy xh8yej3 xspc24f"
    }, {
      children: /*#__PURE__*/_jsx("div", Object.assign({}, {
        className: "xixxii4 x191j7n5 xj46qfm xsam68t"
      }, {
        children: /*#__PURE__*/_jsx(Inline, {
          space: "xs",
          children: children
        })
      }))
    }))
  });
};
export default AutosaveAlertsContainer;